<template>
  <v-row justify="center">
    <v-col cols="12" class="d-flex flex-column align-center">
      <h3 class="text-center kbDarkBlueText--text">
        {{ $t('general.attachFiles') }}
      </h3>
      <p class="text-center kbDarkBlueText--text mt-4" style="max-width: 800px">
        {{ $t('general.attachFilesInCampaignDescription', { size: 24, units: 'mb' }) }}
      </p>

      <div class="mt-4">
        <v-btn
          class="float-right"
          color="kbPurple"
          dark
          @click="openPickFileDialog()"
        >
          {{ $t('general.attachFiles') }}
        </v-btn>
        <input
          class="d-none"
          type="file"
          :multiple="true"
          ref="importerInput"
          @change="pickFiles"
        >
      </div>
    </v-col>

    <v-col cols="12" md="10" v-if="attachments.length">
      <v-list color="kbLight">
        <v-list-item
          class="mb-2"
          v-for="(file, index) in attachments"
          :key="`${index}-${file.name}`"
        >
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">
              mdi-attachment
            </v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text font-weight-medium">
              {{ file.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ file.size / (10 ** 6) }} mb
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn
              color="kbRed"
              icon
              @click="deleteAttachment(index)"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-col>

    <v-col cols="12">
      <v-btn color="kbGrayText"
             @click="updateStep(3)"
             outlined
             class="float-left">
        <v-icon dark>keyboard_arrow_left</v-icon>
        <span class="hidden-xs-only">{{ $t('general.goBack') }}</span>
      </v-btn>

      <v-btn
        color="kbPurple"
        dark
        @click="updateStep(5)"
        class="float-right">
        <span class="hidden-xs-only">{{ $t('general.continue') }}</span>
        <v-icon dark>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import notifications from '@/libs/notifications'
export default {
  computed: {
    getSetAttachments: {
      get () {
        return this.attachments
      },
      set (attachments) {
        this.$emit('onFilesChanged', attachments)
      }
    }
  },
  methods: {
    deleteAttachment (index) {
      this.$delete(this.attachments, index)
    },
    openPickFileDialog () {
      this.$refs.importerInput.click()
    },
    pickFiles (e) {
      let filesToAttach = [...e.target.files]
      const validationResult = this.validateFiles(filesToAttach)
      if (validationResult !== true) return notifications.error(validationResult)

      const existentFilesNames = this.getSetAttachments.map(file => file.name)
      filesToAttach = filesToAttach.filter(file => !existentFilesNames.includes(file.name))
      if (filesToAttach.length === 0) {
        return notifications.error(this.$t('general.fileWithSameNameAlreadyExists'))
      }
      this.getSetAttachments = [...this.getSetAttachments, ...filesToAttach]
    },
    updateStep (step) {
      this.$emit('updateStep', step)
    },
    validateFiles (filesToAttach) {
      let isImportationValid = true
      let totalSizeSum = this.getSetAttachments.reduce((a, b) => a + b, 0)
      for (let i = 0; i < filesToAttach.length; i++) {
        const size = filesToAttach[i].size
        if (size > 5 * 10 ** 6) {
          isImportationValid = this.$t('general.sizeOfFileCantExceed', { size: 5, units: 'mb' })
          break
        }
        totalSizeSum += size
        if (totalSizeSum > 24 * 10 ** 6) {
          isImportationValid = this.$t('general.filesTotalSizeMustBeSmallerThan', { size: 24, units: 'mb' })
          break
        }
      }
      return isImportationValid
    }
  },
  props: {
    attachments: {
      type: Array,
      default: () => []
    }
  }
}
</script>
